<!-- =========================================================================================
  File Name: ArchiveView.vue
  Description: Archive View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-archive-view">

    <vs-alert color="danger" title="Board Not Found" :active.sync="board_not_found">
      <span>Board record with boardEntrySeq: {{ boardEntrySeq }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'archive-list'}" class="text-inherit underline">All Boards</router-link>
      </span>
    </vs-alert>

    <div id="board-data" v-if="board_data">
      <div class="flex justify-between">
        <div>
          <vs-button v-if="board_data.writerID === getUserInfo.userID" class="font-semibold meduim" color="#e7e4fc" text-color="#7367F0" type="filled" :to="{name: 'archive-edit', params: { boardEntrySeq: $route.params.boardEntrySeq }}">수정</vs-button>
          <vs-button v-if="board_data.writerID === getUserInfo.userID" class="font-semibold ml-2 meduim" color="#e7e4fc" text-color="#7367F0" type="filled" @click="confirmDeleteRecord">삭제</vs-button>
        </div>
        <vs-button class="font-semibold meduim" color="#e7e4fc" text-color="#7367F0" type="filled" :to="{name: 'archive-list'}">목록</vs-button>
      </div>
      <vx-card class="mt-4">
        <div>
            <div class="flex">
              <!-- <div class="items-center">
                <feather-icon :icon="'ArrowLeftIcon'" @click="$router.go(-1)" class="cursor-pointer mr-4" svg-classes="w-6 h-6"></feather-icon>
                <h4>{{ board_data.title }}</h4>
              </div> -->
              <h4 class="mt-1">{{ board_data.title }}</h4>
            </div>
            <!-- POST WRITER -->
            <!-- <div class="post-header flex justify-between">
              <div class="w-full flex items-center mt-2">
                  <span class="text-sm">{{ board_data.writerName }}</span>
                  <span class="text-sm ml-4">{{ board_data.createDate }}</span>
                  <span class="text-sm ml-4">조회수 {{ board_data.hits }}</span>
              </div>
            </div> -->
            <div class="flex items-center mt-4">
              <div>
                <vs-avatar class="sender__avatar--single flex-shrink-0 mr-3 border-2 border-solid border-white" size="42px" />
              </div>

              <div class="flex flex-col">
                <h6 class="mb-1">{{ board_data.writerName }}</h6>
                <div class="flex items-center">
                  <span class="text-sm">{{ board_data.createDate | moment('YYYY-MM-DD HH:mm:ss') }}</span>

                  <span class="text-sm ml-4">조회수 {{ board_data.hits }}</span>
                </div>
              </div>
            </div>
            <!-- /POST WRITER -->

            <vs-divider color="#dae1e7"></vs-divider>

            <!-- POST CONTENT -->
            <!-- <div class="post-content mt-10 mr-5 mb-10 ml-5">
                <p>{{ board_data.content }}</p>
            </div> -->
            <div class="vx-row">
              <div class="vx-col w-full">
                <!-- <div class="mail__content break-words mt-4 mb-4" v-html="board_data.content"></div> -->
                <editor-tiptap :description="board_data.content" :menubar="false" :readOnly="true"></editor-tiptap>
              </div>
            </div>
            <!-- /POST CONTENT -->

            <!-- POST ATTACHMENTS -->
            <div class="flex flex-col" v-if="attachList.length">
              <div class="vx-col w-full border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid mb-6 flex">
                <feather-icon icon="PaperclipIcon" class="mr-2"/>
                <span class="block py-4">첨부파일</span>
              </div>
              <div class="">
                <div class="mail__attachment" v-for="(attachment, index) in attachList" :key="index">
                  <vs-chip color="primary" class="px-4 py-2 mr-3">
                    <vs-avatar icon="arrow_downward" color="primary" @click="downloadFile(attachment)"/>{{ attachment.realName }}
                  </vs-chip>
                </div>
              </div>
            </div>
            <!-- /POST ATTACHMENTS -->
        </div>
    </vx-card>

    <!-- POST COMMENTS -->
    <vx-card class="mt-base">
      <archive-comment-list class="mt-4" :data="board_data"/>
    </vx-card>
     
    </div>
  </div>
</template>

<script>
import ArchiveCommentList from './ArchiveCommentList'
import { fetchData, postData, deleteData } from '@/api/module'

export default {
  components: {
    ArchiveCommentList
  },
  data () {
    return {
      boardEntrySeq: this.$route.params.boardEntrySeq,
      board_data: null,
      board_not_found: false,
      attachList: [],
      mode: 'ins',
      writerName: this.$store.getters.getUserInfo.name
    }
  },
  
  computed: {
    validateForm () {
      return !this.errors.any() && this.commentContent
    },
    getUserInfo () {
      return this.$store.getters.getUserInfo
    }
  },
  methods: {
    async downloadFile (attachment) {
      try {
        const fileName = attachment.fileName
        const realName = attachment.realName
        
        const response = await postData(`downloadFile/${fileName}`, '', { 
          responseType: 'blob'
        })

        const blob = new Blob([response.data])
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = realName
        link.click()

      } catch (error) {
        
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '삭제',
        text: '삭제 하시겠습니까?',
        accept: this.deleteRecord,
        acceptText: '삭제'
      })
    },
    async deleteRecord () {
      try {
        await deleteData(`board/${this.boardEntrySeq}`)
        this.$router.push('/archive/archive-list')
        this.showDeleteSuccess()

      } catch (error) {

        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: '삭제',
        text: '삭제 되었습니다.'
      })
    },
    async fetch_board_data () {
      try {
        const { data } = await fetchData(`board/${this.boardEntrySeq}`)
        this.board_data = data.data

      } catch (error) {

        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    async fetch_attach_data () {
      try {
        const { data } = await fetchData(`board/attach/${this.boardEntrySeq}`)
        this.attachList = data.list

      } catch (error) {

        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    }
  },
  created () {
    this.fetch_board_data()
    this.fetch_attach_data()
  }
}

</script>

<style lang="scss">
.editor__content { 
  border: 0px !important;
  height: 100% !important;
}

.meduim {
  padding: .65rem 0.9rem !important;
}
.comment-save {
  height: 64px;
}

#avatar-col {
  width: 10rem;
}

#page-board-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

}

</style>
